export { default } from './LookbooksStatisticsChart'
